export function decodeUnicodeEscapes(input) {
    if (!input)
        return input;
    try {
        // Normalize double-escaped sequences like \\uXXXX to \uXXXX
        const normalized = input.replace(/\\\\u/g, '\\u');
        // Replace \uXXXX with actual unicode characters
        return normalized.replace(/\\u([0-9a-fA-F]{4})/g, (_, hex) => String.fromCharCode(parseInt(hex, 16)));
    }
    catch (_a) {
        return input;
    }
}
//# sourceMappingURL=TextHelper.js.map